export const P2P_TABLE_POLL_MS = 0;

export function p2pRecordRowKey(record: {
    platform?: string | null;
    ad_id?: string | null;
    id?: string | null;
    name?: string | null;
}): string {
    return `${record.platform || 'p2p'}::${record.ad_id || record.id || record.name || 'row'}`;
}
